import React from 'react';

const Liechtenstein = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" fill="#F93939" />
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 0H28V9.33333H0V0Z" fill="#1A47B8" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.3335 6.6665H10.6668V7.99984H5.3335V6.6665Z" fill="#D4AF2C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.68 4.18917C6.26933 4.0825 5.8 3.99984 5.33333 3.99984C4 3.99984 4 4.6665 4 5.33317C4 5.99984 5.33333 6.6665 5.33333 6.6665H10.6667C10.6667 6.6665 12 5.99984 12 5.33317C12 4.6665 12 3.99984 10.6667 3.99984C10.2 3.99984 9.73067 4.0825 9.32 4.18917C9.32933 4.1265 9.33333 4.06384 9.33333 3.99984C9.33333 3.26384 8.736 2.6665 8 2.6665C7.264 2.6665 6.66667 3.26384 6.66667 3.99984C6.66667 4.06384 6.67067 4.1265 6.68 4.18917Z"
      fill="#FFDA2C"
    />
  </svg>
);

export default Liechtenstein;
